
window.PB_HT = window.PB_HT || {};


window.PB_HT.filesBase = '';

window.PB_HT.assetBase = window.PB_HT.assetBase || '';


window.PB_HT.models = [
  {
    code: '630L-115',
    name: 'Equinox 630L',
    variant: '115 V · Plug & Play',
    handle: '',                       
    seats: 4, seatsLabel: '4 person', lounger: true,
    dims: { l: 79, w: 79, h: 34 },    
    capacityL: 1108, capacityGal: 298,
    jets: 30,
    voltage: 115, plugAndPlay: true,
    pumps: 'One 1.5 HPR dual-speed pump',
    heater: '1 kW titanium heater',
    controls: 'Balboa digital controls, TP500S keypad',
    filtration: 'DynaFlo single twist-and-lock cartridge',
    lighting: 'LED safety light, perimeter LED, LED cupholders',
    cover: 'Black thermal cover (5"–3" taper) included',
    defining: 'Runs on a standard outlet — no electrician required to enjoy it.',
    bestFor: ['compact', 'easy-install', 'hydrotherapy'],
    asset: 'pb-ht-eq-630l.webp', blurb: "Compact, quiet and plug-and-play. The lounger you can enjoy the week it arrives — on a standard outlet, with no electrician on the schedule.",
    image: 'pb-ht-630l.png', imageAlt: 'Equinox 630L hot tub, official render',
    specSheet: 'pb-ht-spec-630l-115.pdf', manual: 'pb-ht-manual-equinox-2025.pdf'
  },
  {
    code: '630L-230',
    name: 'Equinox 630L',
    variant: '230 V',
    handle: '',
    seats: 4, seatsLabel: '4 person', lounger: true,
    dims: { l: 79, w: 79, h: 34 },
    capacityL: 1108, capacityGal: 298,
    jets: 30,
    voltage: 230, plugAndPlay: false,
    pumps: 'One 4.5 HPR dual-speed pump',
    heater: '4 kW titanium heater',
    controls: 'Balboa digital controls, TP500S keypad',
    filtration: 'DynaFlo single twist-and-lock cartridge',
    lighting: 'LED safety light, perimeter LED, LED cupholders',
    cover: 'Black thermal cover (5"–3" taper) included',
    defining: 'The compact lounger with the full-size heater — recovers fast after a winter soak.',
    bestFor: ['compact', 'hydrotherapy'],
    asset: 'pb-ht-eq-630l-storm.webp', blurb: "The same intimate four-seat lounger, hard-wired for the full-size heater. Warms quickly after a snowfall and keeps up on the coldest nights.",
    image: 'pb-ht-630l.png', imageAlt: 'Equinox 630L hot tub, official render',
    specSheet: '', manual: 'pb-ht-manual-equinox-2025.pdf'
  },
  {
    code: '743L-230',
    name: 'Equinox 743L',
    variant: '230 V',
    handle: '',
    seats: 5, seatsLabel: '5 person', lounger: true,
    dims: { l: 88, w: 88, h: 38 },
    capacityL: 1590, capacityGal: 420,
    jets: 43,
    voltage: 230, plugAndPlay: false,
    pumps: 'Two 5.0 SPL dual-speed pumps',
    heater: '4 kW titanium heater',
    controls: 'Balboa digital controls, TP500S keypad',
    filtration: 'DynaFlo single twist-and-lock cartridge',
    lighting: 'LED safety light, perimeter LED, LED cupholders',
    cover: 'Black thermal cover (5"–3" taper) included',
    defining: 'Full-size lounger with twin pumps — the hydrotherapy seat in the range.',
    bestFor: ['hydrotherapy', 'entertaining'],
    asset: 'pb-ht-eq-743l-espresso.webp', blurb: "Forty-three jets, twin pumps and a full-length lounge. The therapy seat in the range — built for the nights your shoulders need it most.",
    image: 'pb-ht-743l.png', imageAlt: 'Equinox 743L hot tub, official render',
    specSheet: 'pb-ht-spec-743l.pdf', manual: 'pb-ht-manual-equinox-2025.pdf'
  },
  {
    code: '744B-230',
    name: 'Equinox 744B',
    variant: '230 V',
    handle: 'equinox-744b-7-person-hot-tub-spa-copy',
    seats: 7, seatsLabel: '7 person', lounger: false,
    dims: { l: 88, w: 88, h: 38 },
    capacityL: 1590, capacityGal: 420,
    jets: 44,
    voltage: 230, plugAndPlay: false,
    pumps: 'Two 5.0 SPL dual-speed pumps',
    heater: '4 kW titanium heater',
    controls: 'Balboa digital controls, TP500S keypad',
    filtration: 'DynaFlo single twist-and-lock cartridge',
    lighting: 'LED safety light, perimeter LED, LED cupholders',
    cover: 'Black thermal cover (5"–3" taper) included',
    defining: 'Open bench seating for seven — the one for a full backyard on a Saturday night.',
    bestFor: ['max-seating', 'entertaining'],
    asset: 'pb-ht-eq-744b-storm.webp', blurb: "Seven open seats around the water, nobody stuck in a corner. The tub for a full deck on a Saturday night in January.",
    image: 'pb-ht-744b.png', imageAlt: 'Equinox 744B hot tub, official render',
    specSheet: 'pb-ht-spec-744b.pdf', manual: 'pb-ht-manual-equinox-2025.pdf'
  }
];


window.PB_HT.range = {
  shell: 'Fiberglass-reinforced acrylic shell, UV resistant',
  frame: 'Galvanized steel frame engineered to support over 7,000 lb',
  cabinet: 'Maintenance-free Polysteel cabinet — resistant to rotting, cracking and peeling',
  insulation: 'Rockwool GreenGuard insulation made from natural stone and recycled content',
  base: 'Fully insulated ABS bottom tray',
  
  shells: [
    { name: 'Silver Marble', asset: 'pb-ht-eq-shell-silver-marble.webp' },
    { name: 'Cosmic Swirl', asset: 'pb-ht-eq-shell-cosmic.webp' },
    { name: 'Black Opal', asset: 'pb-ht-eq-shell-black-opal.webp' }
  ],
  cabinets: [
    { name: 'Black Polysteel', asset: 'pb-ht-eq-cabinet-black.webp' },
    { name: 'Grey Polysteel', asset: 'pb-ht-eq-cabinet-grey.webp' }
  ],
  finishNote: 'Shell and cabinet names as shown on equinoxspas.com; confirm current availability with Pool Busters.',
  warranty: [
    ['Shell structure', '10 years'],
    ['Shell surface', '5 years'],
    ['Plumbing & electrical', '3 years'],
    ['Cabinet', '2 years'],
    ['Accessories', '90 days']
  ],
  warrantyNote: 'Applies to spas manufactured after 1 January 2024. Covers and cover lifters are not included in the manufacturer warranty. Ask Pool Busters for the current warranty document.',
  
  verify: ['230 V amperage per model', 'dry and filled weight', 'ozone standard or optional', 'steps included with delivery']
};



window.PB_HT.filters = [
  { models: ['630L', '743L', '744B'], from: 2024, to: 2030, part: 'PLBS75', name: 'DynaFlo 75 sq ft cartridge',
    size: '14 13/16" high, twist-and-lock', handle: '', note: 'Fits 2024 and newer Equinox spas (2024 and 2025 owner\'s manuals).' },
  { models: ['630L', '743L', '744B'], from: 2021, to: 2023, part: 'PRB-50', name: '50 sq ft cartridge (R9026110)',
    size: '4 15/16" × 13 5/16"', handle: '', note: 'Fits 2021–2023 Equinox spas.' },
  { models: ['630L', '743L', '744B'], from: 2018, to: 2020, part: 'PWW50L-PAK50', name: '50 sq ft teleweir cartridge (R9026104)',
    size: '5" × 13 7/8"', handle: '', note: 'Fits 2018–2020 Equinox spas.' }
];
window.PB_HT.filterYears = { min: 2018, max: 2026 };



window.PB_HT.cover = {
  shapes: [
    { id: 'square',    name: '90° corners',        dims: ['A', 'B'],      radius: false },
    { id: 'rounded',   name: 'Round corners',      dims: ['A', 'B'],      radius: true  },
    { id: 'round',     name: 'Round',              dims: ['A'],           radius: false, aLabel: 'Diameter' },
    { id: 'octagon',   name: 'Octagon',            dims: ['A', 'B', 'C'], radius: false },
    { id: 'cut1',      name: 'One cut corner',     dims: ['A', 'B', 'C'], radius: false },
    { id: 'cut2',      name: 'Two cut corners',    dims: ['A', 'B', 'C'], radius: false },
    { id: 'cut4',      name: 'Four cut corners',   dims: ['A', 'B', 'C'], radius: false },
    { id: 'swim',      name: 'Swim spa / multi-panel', dims: ['A', 'B'],  radius: true  }
  ],
  tapers: ['3" ▸ 2"', '4" ▸ 2"', '4" ▸ 3"', '5" ▸ 3"', '5" ▸ 4"', '6" ▸ 4"'],
  taperUpgrade: '2 lb foam upgrade',
  folds: ['Bi-fold (standard)', 'Tri-fold', 'Quad-fold'],
  foldDirections: ['Fold along A', 'Fold along B', 'Let HST split the longest measurement'],
  hoods: ['None', '2 speaker hoods', '4 speaker hoods'],
  upgrades: [
    { id: 'overlap',  name: 'Overlap skirt' },
    { id: 'seal',     name: 'Full centre seal' },
    { id: 'vb4',      name: 'Vapour barrier — 4 mil', group: 'vb' },
    { id: 'vb6',      name: 'Vapour barrier — 6 mil', group: 'vb' },
    { id: 'vb8',      name: 'Vapour barrier — 8 mil', group: 'vb' },
    { id: 'alu',      name: 'Double aluminum' },
    { id: 'seam',     name: 'Seam protector' },
    { id: 'reflect',  name: 'Reflective liner' }
  ],
  bundles: [
    { id: 'better', name: 'Better Cover', includes: ['4 mil vapour barrier', 'Overlap skirt at centre', 'Full foam centre seal'] },
    { id: 'best',   name: 'Best Cover',   includes: ['6 mil vapour barrier', 'Overlap skirt at centre', 'Full foam seal', 'Set of 2 rubber handles'] }
  ],
  
  colours: [
    { material: 'Spa Cover Vinyl', name: 'Almond',       hex: '#D9C3A0', file: 'pb-ht-swatch-almond.webp' },
    { material: 'Spa Cover Vinyl', name: 'Ash Grey',     hex: '#8E9093', file: 'pb-ht-swatch-ash-grey.webp' },
    { material: 'Spa Cover Vinyl', name: 'Black',        hex: '#1E1F21', file: 'pb-ht-swatch-black.webp' },
    { material: 'Spa Cover Vinyl', name: 'Brown',        hex: '#5A3A2C', file: 'pb-ht-swatch-brown.webp' },
    { material: 'Spa Cover Vinyl', name: 'Burgundy',     hex: '#6E2C3B', file: 'pb-ht-swatch-burgundy.webp' },
    { material: 'Spa Cover Vinyl', name: 'Charcoal',     hex: '#2C3138', file: 'pb-ht-swatch-charcoal.webp' },
    { material: 'Spa Cover Vinyl', name: 'Chestnut',     hex: '#5B3A2E', file: 'pb-ht-swatch-chestnut.webp' },
    { material: 'Spa Cover Vinyl', name: 'Hunter Green', hex: '#1F3F39', file: 'pb-ht-swatch-hunter-green.webp' },
    { material: 'Spa Cover Vinyl', name: 'Light Grey',   hex: '#8E9298', file: 'pb-ht-swatch-light-grey.webp' },
    { material: 'Spa Cover Vinyl', name: 'Mahogany',     hex: '#8A4A47', file: 'pb-ht-swatch-mahogany.webp' },
    { material: 'Spa Cover Vinyl', name: 'Navy',         hex: '#2A4666', file: 'pb-ht-swatch-navy.webp' },
    { material: 'Spa Cover Vinyl', name: 'Sky Blue',     hex: '#5F8CB5', file: 'pb-ht-swatch-sky-blue.webp' },
    { material: 'Spa Cover Vinyl', name: 'Tan',          hex: '#B9925C', file: 'pb-ht-swatch-tan.webp' },
    { material: 'Spa Cover Vinyl', name: 'Teal',         hex: '#2F5E63', file: 'pb-ht-swatch-teal.webp' },
    { material: 'Specialty Vinyl', name: 'Carbon',       hex: '#3A3B3D', file: 'pb-ht-swatch-carbon.webp', specialty: true },
    { material: 'Specialty Vinyl', name: 'Merlot',       hex: '#4A2E2C', file: 'pb-ht-swatch-merlot.webp', specialty: true },
    { material: 'Pro-Tex',         name: 'Black',        hex: '#232527', file: 'pb-ht-swatch-protex-black.webp' },
    { material: 'Pro-Tex',         name: 'Charcoal',     hex: '#4A4E54', file: 'pb-ht-swatch-protex-charcoal.webp' },
    { material: 'Pro-Tex',         name: 'Chestnut',     hex: '#6B3F2C', file: 'pb-ht-swatch-protex-chestnut.webp' },
    { material: 'Pro-Tex',         name: 'Forest Green', hex: '#2C5A43', file: 'pb-ht-swatch-protex-forest-green.webp' },
    { material: 'Pro-Tex',         name: 'Navy',         hex: '#2B3550', file: 'pb-ht-swatch-protex-navy.webp' }
  ]
};



window.PB_HT.quiz = [
  { id: 'people', q: 'How many people will usually use the spa?',
    opts: [
      { t: '1–2', score: { '630L-115': 3, '630L-230': 3, '743L-230': 1, '744B-230': 0 } },
      { t: '3–4', score: { '630L-115': 2, '630L-230': 2, '743L-230': 3, '744B-230': 2 } },
      { t: '5–6', score: { '630L-115': 0, '630L-230': 0, '743L-230': 3, '744B-230': 3 } },
      { t: '7 or more', score: { '630L-115': 0, '630L-230': 0, '743L-230': 1, '744B-230': 4 } }
    ] },
  { id: 'lounger', q: 'Do you want a lounger seat?',
    opts: [
      { t: 'Yes — a full-length lounge', score: { '630L-115': 2, '630L-230': 2, '743L-230': 3, '744B-230': -2 } },
      { t: 'No — open bench seating', score: { '630L-115': -1, '630L-230': -1, '743L-230': -1, '744B-230': 4 } },
      { t: 'No preference', score: {} }
    ] },
  { id: 'plug', q: 'Is plugging into a standard outlet important?',
    help: 'A 115 V plug-and-play spa runs from a standard outlet. 230 V spas heat faster and run stronger pumps but need a dedicated electrical connection.',
    opts: [
      { t: 'Yes — I want plug-and-play', score: { '630L-115': 5, '630L-230': -2, '743L-230': -2, '744B-230': -2 } },
      { t: 'No — 230 V is fine', score: { '630L-115': -2, '630L-230': 2, '743L-230': 2, '744B-230': 2 } },
      { t: 'Not sure', score: {} }
    ] },
  { id: 'electrical', q: 'Do you already have 230 V service available in the backyard?',
    opts: [
      { t: 'Yes', score: { '630L-230': 1, '743L-230': 1, '744B-230': 1 } },
      { t: 'No, but I can add it', score: {} },
      { t: 'No, and I would rather not', score: { '630L-115': 3 } }
    ] },
  { id: 'matters', q: 'What matters most?',
    opts: [
      { t: 'Hydrotherapy', score: { '630L-115': 1, '630L-230': 2, '743L-230': 4, '744B-230': 2 } },
      { t: 'Entertaining', score: { '743L-230': 2, '744B-230': 4 } },
      { t: 'Compact footprint', score: { '630L-115': 3, '630L-230': 3 } },
      { t: 'Easy installation', score: { '630L-115': 4 } },
      { t: 'Maximum seating', score: { '744B-230': 5, '743L-230': 1 } }
    ] }
];
